import { FormSectionHandler } from '../entity.handler';
import { AssetGroupResponse, IdName, AssetGroupUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    parent?: IdName;
}


export class AssetGroupDetailsSectionHandler implements FormSectionHandler<AssetGroupResponse, EditorValues> {

    type = 'form';
    icon = ICONS.assetgroup;
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService
    ) {
    }

    private properties = ['name', 'parent'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSETGROUP.DETAILS.${key}`, values);
    }

    applyUpdate(entity: AssetGroupResponse, payload: AssetGroupUpdateRequest): Promise<AssetGroupResponse> {
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.updateAssetGroup(entity.id, payload));
    }

    mapEntityToEditor(entity: AssetGroupResponse): Promise<EditorValues> {
        if (!entity.parent) {
            entity.parent = { id: 'root', name: this.admin.i18n.instant('SHARED.ROOT') };
        }
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: AssetGroupUpdateRequest, values: EditorValues): Promise<AssetGroupUpdateRequest> {
        const result = EntityUtils.mergeFields<AssetGroupUpdateRequest>(this.properties, values, entity);
        if (result.parent && result.parent.id === 'root') {
            result.parent = null;
        }
        return Promise.resolve(result);
    }

    getFields(entity: AssetGroupResponse): Promise<FormBuilderField[]> {
        return this.grouping.getAssetGroups(this.ownerId).then(assetGroups => {

            const values = [
                { key: 'root', value: this.admin.i18n.instant('SHARED.ROOT') },
                ...EntityUtils.treeToComboValues(assetGroups, 1),
            ];

            return [
                ComboField('parent', this.translate('FIELDS.PARENT'), true, values, IdNameComboValueHandlers),
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
